module.exports = __webpack_public_path__ + "img/evoplay.7e15e0f8.110ecdb0.png";